import type { ReactNode } from 'react';
import { CodeField } from '../../../ds/components';
import styles from './CodeInput.module.css';

export interface CodeInputProps {
  length?: 6 | undefined;
  value: string;
  onChange: (value: string) => void;
  onComplete?: ((value: string) => void) | undefined;
  /** Red boxes and the message below („Noch 3 Versuche. …"). */
  error?: ReactNode | undefined;
  /** Accessible name of the group; defaults to „Bestätigungscode". */
  label?: string | undefined;
  disabled?: boolean | undefined;
  autoFocus?: boolean | undefined;
}

/** The six code boxes of the onboarding frames as one labelled group. */
export function CodeInput({
  length = 6,
  value,
  onChange,
  onComplete,
  error,
  label = 'Bestätigungscode',
  disabled,
  autoFocus,
}: CodeInputProps) {
  return (
    <div className={styles.wrap}>
      <CodeField
        label={label}
        labelHidden
        length={length}
        value={value}
        onChange={onChange}
        onComplete={onComplete}
        invalid={Boolean(error)}
        disabled={disabled}
        autoFocus={autoFocus}
        className={styles.code}
      />
      {error ? (
        <div className={styles.message} role="alert">
          {error}
        </div>
      ) : null}
    </div>
  );
}
